<template>
  <section v-if="featuredSerie.active" id="home-featured-serie" :style="{backgroundColor: featuredSerie.colorBackground}">
    <div class="featured-serie">
      <div class="featured-serie__header">
      <div class="featured-serie__heading" :style="{color: featuredSerie.colorHeading}">
        {{ featuredSerie.heading}}
      </div>
      <router-link class="button-default"
                   :to="{name: 'Serie', params: {id: featuredSerie.permlink}}"
      >
        view all
      </router-link>
      </div>
      <HomeFeaturedCarousel v-if="featuredSerie.episodes"
                            carousel-id="featured-serie"
                            :featured-data="featuredSerie.episodes"
      />
    </div>
  </section>
</template>

<script>
import axios from "axios";
import HomeFeaturedCarousel from "@/components/sections/HomeFeaturedCarousel.vue";

export default {
  name: "HomeFeaturedSerie",
  components: {HomeFeaturedCarousel},
  data() {
    return {
      loading: false,
      featuredSerie: {
        active: false,
        heading: '',
        colorHeading: '',
        colorBackground: '',
        episodes: [],
        permlink: ''
      }
    }
  },
  mounted() {
    this.getFeaturedSerieEpisodes();
  },
  methods: {
    getFeaturedSerieEpisodes() {
      this.loading = true;
      axios
          .get(this.$router.options.api + '/front/get-featured-serie')
          .then(response => {
            this.featuredSerie.active = response.data.active;
            this.featuredSerie.episodes = response.data.episodes !== null ? response.data.episodes : [];
            this.featuredSerie.heading = response.data.title;
            this.featuredSerie.colorHeading = response.data.colorText;
            this.featuredSerie.colorBackground = response.data.colorBackground;
            this.featuredSerie.permlink = response.data.serie !== null ? response.data.serie.permlink : '';
          })
          .catch(error => console.error(error))
          .finally(() => (this.loading = false));
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/variables";
#home-featured-serie {
  padding: 40px 0;
  @include media-breakpoint-down(lg) {
    padding: 20px 0;
  }
}

.featured-serie {
  &__header {
    margin-bottom: 45px;
    display: flex;
    justify-content: space-between;
  }
  &__heading {
    @include font-18-md();
    width: 70%;
  }
}
</style>
